import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var y = /*#__PURE__*/function () {
  function y() {
    _classCallCheck(this, y);
  }

  _createClass(y, [{
    key: "Rs",
    value: function Rs() {}
  }, {
    key: "changeUser",
    value: function changeUser(a) {}
  }, {
    key: "clearData",
    value: function clearData() {}
  }]);

  return y;
}();

export { y as default };